import {Routes} from '@angular/router'
import projectRoutes from './ui/project/project.routes'

export const routes: Routes = [
  ...projectRoutes
]
